import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
const UnknownComponent = ({ type, component, }) => {
    const { isDev } = usePlatform();
    if (!isDev) {
        return null;
    }
    return (_jsxs("div", { style: { padding: '16px', border: '1px dashed #ccc', margin: '8px 0' }, children: [_jsxs("strong", { children: ["Unknown Component Type: ", type] }), _jsxs("details", { style: { marginTop: '8px' }, children: [_jsx("summary", { children: "Component Data" }), _jsx("pre", { style: { fontSize: '12px', overflow: 'auto' }, children: JSON.stringify(component, null, 2) })] })] }));
};
export default UnknownComponent;
